(function() {
  'use strict';
  if (window.__cmStickyToolbarInit) return;
  window.__cmStickyToolbarInit = true;
  var MIN_WIDTH = 1024;

  function initToolbar(toolbar) {
    var modifiedAncestors = [];
    var isActive = false;

    function unblockAncestors() {
      var node = toolbar.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        var s = window.getComputedStyle(node);
        var entry = { el: node };
        var changed = false;

        
        if (s.overflowY === 'hidden' || s.overflowY === 'clip' || s.overflowY === 'auto' || s.overflowY === 'scroll') {
          entry.overflowY = node.style.overflowY;
          node.style.overflowY = 'visible';
          changed = true;
        }
        if (s.overflowX === 'auto' || s.overflowX === 'scroll') {
          entry.overflowX = node.style.overflowX;
          node.style.overflowX = 'clip';
          changed = true;
        }
        if (changed) modifiedAncestors.push(entry);
        node = node.parentElement;
      }
    }

    function restoreAncestors() {
      modifiedAncestors.forEach(function(e) {
        if ('overflowY' in e) e.el.style.overflowY = e.overflowY;
        if ('overflowX' in e) e.el.style.overflowX = e.overflowX;
      });
      modifiedAncestors = [];
    }

    function activate() {
      if (isActive) return;
      isActive = true;
      unblockAncestors();
      toolbar.style.position = 'sticky';
      toolbar.style.top = '0';
      toolbar.style.zIndex = '10';
    }

    function deactivate() {
      if (!isActive) return;
      isActive = false;
      restoreAncestors();
      toolbar.style.position = '';
      toolbar.style.top = '';
      toolbar.style.zIndex = '';
    }

    function apply() {
      if (window.innerWidth >= MIN_WIDTH) activate();
      else deactivate();
    }

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 100);
    }, { passive: true });

    apply();
  }

  function init() {
    
    var toolbars = document.querySelectorAll('.js-collection-sticky-toolbar');
    toolbars.forEach(initToolbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
